import { AEMErrorMessage } from '@com-delta-idp/mnx-skymiles-shared';

export const FullPageErrorMessage: AEMErrorMessage = {
  action: {
    label: 'Delta.com',
    url: '/',
    id: ''
  },
  component: 'full-page',
  errorId: [],
  featureTitle: '',
  errorMessageDescription:
    "We're sorry, but we are currently unable to display the Sky Club page due to a technical issue. Please try again later.",
  errorMessageTitle:
    'Whoops! Looks Like This Page Is Having a Flight Delay. Please Try Again Later.',
  type: 'full-page'
};
